import axios, { type AxiosResponse } from "axios";
import { AxiosError } from "axios";
import { type DjangoRestFrameworkErrorType } from "@/utils/DjangoError";
import type { FieldChoicableType } from "@/utils/FormUtils";
import useLoginManager from "@/services/loginManager";
import { getRestServiceUri } from "@/utils/ApiUtils";

export interface ApiService {
  get: (id: number) => Promise<AxiosResponse<FieldChoicableType>>;
}

export const HTTP = axios.create({
  baseURL: getRestServiceUri(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Add authorization header to every request
HTTP.interceptors.request.use(async function (config) {
  const loginManager = useLoginManager();
  if (loginManager.isLogged.value) {
    if (!loginManager.accessToken.value) {
      loginManager.logout();
      return config;
    }

    config.headers.set("Authorization", `Bearer ${loginManager.accessToken.value}`);
  }
  return config;
});

HTTP.interceptors.response.use(
  (response) => response,
  (error: AxiosError<DjangoRestFrameworkErrorType>) => {
      return Promise.reject(error);
  }
);